import { cHeader } from "../header";

export class cAccountMenu {

  parent              = document.querySelector('.c-account-menu .c-customer-selection') as HTMLElement;
  script              = document.querySelector('.c-customer-selection script')          as HTMLScriptElement;
  accountMenu         = document.querySelector('.c-account-menu')                       as HTMLElement;
  accountMenuOverview = document.querySelector('.c-account-menu div:nth-child(1)')      as HTMLElement
  accountMenuDisplay  = document.querySelector('.c-account-menu div:nth-child(2)')      as HTMLElement

  customerId : string            = '';
  json       : CustomerSelection = {customerId: '', customers: []};

  constructor(top: cHeader) {

    // ---- init ----
    if (this.script === null) return;
    this.json = JSON.parse(this.script.innerText);
    this.customerId = this.json.customerId;
    this.customerSelection(this.parent);

    // ---- events ----
    this.accountMenuOverview.addEventListener('click', (e) => {
      e.stopPropagation();

      if (this.accountMenu.classList.contains('c-open')) {
        top.closeAll();
      }
      else {
        top.closeAll();
        this.accountMenu.classList.add('c-open');
      }
    });

    this.accountMenuDisplay.addEventListener('click', (e) =>{
      e.stopPropagation();
    });
  }

  close() {
    if (this.script === null) return;
    this.accountMenu.classList.remove('c-open');
  }

  customerSelection(parent: HTMLElement) {
    if (this.json.customers.length === 0) return;

    this.json.customers.sort((a, b) => {
      const aIsTest = a.name && a.name.toLowerCase().includes('test ');
      const bIsTest = b.name && b.name.toLowerCase().includes('test ');
      if (aIsTest === bIsTest) return 0;
      return aIsTest ? -1 : 1;
    });

    const fieldset_customer = document.createElement('fieldset');
    const select_customer   = document.createElement('select');
  
    parent.append(fieldset_customer);
      fieldset_customer.append(select_customer);

        for(const customer of this.json.customers) {
          const option     = document.createElement('option');
          option.value     = customer.id;
          option.innerText = customer.name;
          option.selected  = customer.id === this.customerId;
          select_customer.append(option);
        }

    select_customer.addEventListener('change', () => {
      this.customerId = select_customer.value;
      this.setCookie('c-customer', this.customerId, 365);
      window.location.reload();
    });
  }

  setCookie(name: string, value: string, days: number) {
    const date = new Date();
    date.setTime(date.getTime() + days*24*60*60*1000);
    const expires = date.toUTCString();
    document.cookie = `${name}=${value};expires=${expires};path=/`
  }
}